<div fxLayout>
  <sbnb-subnav>
    <sbnb-back-button [disableRedirect]="true" (click)="goBack()" style="margin-bottom: 20px"></sbnb-back-button>
    <sbnb-helptext-wrapper [area]="'sidebar'" [pageId]="'direct-booking-policies-edit'"></sbnb-helptext-wrapper>
  </sbnb-subnav>

  <main fxFlex [ngClass.lt-md]="{ mobile: true }" class="subnav__exists relative" fxLayout="column" fxLayoutGap="24px">
    <ng-container *ngIf="policy">
      <app-feature-flag-tabs>
        <sbnb-page-header navTabs class="!mb-0 block sbnbDesktop:hidden"></sbnb-page-header>
      </app-feature-flag-tabs>
      <section id="header">
        <div fxLayout="column" fxFlex>
          <h2 class="input__editable nomargin" fxFlex>
            <span
              #nameSpan
              style="padding-left: 0; padding-right: 8px; visibility: hidden; position: absolute; left: -9999px">
              {{ policy.name }}
            </span>
            <input
              class="input__borderless"
              type="text"
              [style.width.px]="nameSpan.getBoundingClientRect().width"
              [(ngModel)]="policy.name" />
          </h2>

          <span fxFlex style="padding-left: 4px; padding-top: 8px; font-size: 14px">
            Configure a payment and refund schedule to manage direct bookings.
          </span>
        </div>

        <sbnb-button *ngIf="!recentlySaved" size="mini" [loading]="saving" (clicked)="saveChanges()">Save</sbnb-button>

        <div *ngIf="recentlySaved" fxLayout fxLayoutAlign="center center">
          <mat-icon class="grass-darker">check</mat-icon>
          <span class="grass-darker">Saved</span>
        </div>
      </section>

      <section id="content">
        <section id="cancellation-policy">
          <div fxLayout fxLayoutGap="24px" fxLayoutAlign="start center">
            <div fxLayout="column" fxLayoutGap="12px">
              <div fxLayout="row" fxFlex fxLayoutGap="12px">
                <img src="/assets/iconography/calendar-block.svg" />
                <h3>Cancellation policy</h3>
              </div>

              <span fxLayout="row" fxFlex style="font-size: 14px">
                Refunds are calculated according to whichever policy is active when the booking is made. All
                reservations become non-refundable after the last rule expires or at check-in, whichever comes earlier.
              </span>
            </div>
          </div>

          <div class="section-content mt-4">
            <div class="section-content flex flex-col">
              <ng-container
                *ngTemplateOutlet="
                  termsTemplate;
                  context: {
                    type: CancellationTermType.AfterBooking,
                    canAddNewTermOfType: CancellationTermType.BeforeCheckIn
                  }
                "></ng-container>
              <ng-container
                *ngTemplateOutlet="termsTemplate; context: { type: CancellationTermType.BeforeCheckIn }"></ng-container>
            </div>
          </div>
        </section>

        <section id="payment-schedule" class="mb-8">
          <div fxLayout fxLayoutGap="24px" fxLayoutAlign="start center">
            <div fxLayout="column" fxLayoutGap="12px">
              <div fxLayout="row" fxFlex fxLayoutGap="12px">
                <img src="/assets/iconography/calendar-cash-1.svg" />
                <h3>Payment schedule</h3>
              </div>

              <span fxLayout="row" fxFlex style="font-size: 14px">
                Offer guests the option to pay in up to three installments. The number of payments will depend on the
                lead time of a reservation. Hospitable will attempt to automatically capture each scheduled payment.
              </span>
            </div>
          </div>

          <div class="section-content mt-4">
            <section>
              <mat-form-field fxFlex="grow" class="nopadding">
                <mat-select
                  [(ngModel)]="policy.payment_terms_status"
                  (ngModelChange)="alignedWithPaymentTermsChanged($event)">
                  <mat-select-trigger>
                    <ng-container [ngSwitch]="policy.payment_terms_status">
                      <ng-container *ngSwitchCase="PaymentTermStatus.Aligned">
                        <ng-container *ngTemplateOutlet="alignPaymentSchedule"></ng-container>
                      </ng-container>

                      <ng-container *ngSwitchCase="PaymentTermStatus.Manual">
                        <ng-container *ngTemplateOutlet="customPaymentSchedule"></ng-container>
                      </ng-container>

                      <ng-container *ngSwitchCase="PaymentTermStatus.Disabled">
                        <ng-container *ngTemplateOutlet="disablePaymentSchedule"></ng-container>
                      </ng-container>
                    </ng-container>
                  </mat-select-trigger>

                  <mat-option class="flex" [value]="PaymentTermStatus.Aligned">
                    <ng-container *ngTemplateOutlet="alignPaymentSchedule"></ng-container>
                  </mat-option>
                  <mat-option [value]="PaymentTermStatus.Manual">
                    <ng-container *ngTemplateOutlet="customPaymentSchedule"></ng-container>
                  </mat-option>
                  <mat-option [value]="PaymentTermStatus.Disabled">
                    <ng-container *ngTemplateOutlet="disablePaymentSchedule"></ng-container>
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <ng-template #alignPaymentSchedule>
                <div class="flex">
                  <span class="flex grow">
                    Align my payment terms with my cancellation policy

                    <span class="flex text-grass-darker italic ml-4">Recommended</span>
                  </span>
                </div>
              </ng-template>

              <ng-template #disablePaymentSchedule>
                <div class="flex">
                  <span class="flex grow">Guests always pay 100% upfront</span>
                </div>
              </ng-template>

              <ng-template #customPaymentSchedule>
                <div class="flex">
                  <span class="flex grow">Set a custom payment schedule</span>
                </div>
              </ng-template>
            </section>

            <section *ngIf="policy.payment_terms_status === PaymentTermStatus.Manual">
              <div class="section-content">
                <ng-container
                  *ngTemplateOutlet="
                    termsTemplate;
                    context: {
                      type: CancellationTermType.PaymentTermsAfterAccepted,
                      canAddNewTermOfType: CancellationTermType.PaymentTermsBeforeCheckin
                    }
                  "></ng-container>
                <ng-container
                  *ngTemplateOutlet="
                    termsTemplate;
                    context: { type: CancellationTermType.PaymentTermsBeforeCheckin }
                  "></ng-container>
              </div>
            </section>

            <section class="mt-4" *ngIf="policy.payment_terms_status !== PaymentTermStatus.Disabled">
              <div class="section-content" fxLayout fxLayoutGap="16px" fxLayoutAlign="start center">
                <div>
                  <mat-form-field class="nopadding">
                    <mat-select [(ngModel)]="policy.grace_period_in_hours">
                      <mat-select-trigger>
                        <ng-container [ngSwitch]="policy.grace_period_in_hours">
                          <ng-container *ngSwitchCase="48">48 hours</ng-container>

                          <ng-container *ngSwitchCase="72">72 hours</ng-container>

                          <ng-container *ngSwitchCase="168">1 week</ng-container>
                        </ng-container>
                      </mat-select-trigger>

                      <mat-option class="flex" [value]="48">48 hours</mat-option>
                      <mat-option [value]="72">72 hours</mat-option>
                      <mat-option [value]="168">1 week</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <span>grace period on missed payments before cancelling a booking</span>
              </div>
            </section>
          </div>
        </section>

        <ng-container *ngIf="isPremium$ | async">
          <section id="payment-schedule" class="mb-8">
            <div fxLayout fxLayoutGap="24px" fxLayoutAlign="start center">
              <div fxLayout="column" fxLayoutGap="12px">
                <div fxLayout="row" fxFlex fxLayoutGap="12px">
                  <sbnb-icon icon="accounting-coins-stack" class="shrink-0 text-smoke-darker"></sbnb-icon>
                  <h3>Service fees</h3>
                </div>

                <span fxLayout="row" fxFlex style="font-size: 14px">
                  Choose to split the fee, or select the host-only option to hide the booking fee from guests.
                </span>
              </div>
            </div>

            <div class="section-content mt-4">
              <section>
                <mat-form-field fxFlex="grow" class="nopadding">
                  <mat-select [(ngModel)]="policy.host_only_service_fee_enabled">
                    <mat-option class="flex" [value]="false">4% guest service fee + 3% host service fee</mat-option>
                    <mat-option [value]="true">7% host service fee</mat-option>
                  </mat-select>
                </mat-form-field>
              </section>
            </div>
          </section>
        </ng-container>

        <section id="scoping">
          <div fxLayout fxLayoutGap="24px" fxLayoutAlign="start center">
            <div fxLayout fxLayoutAlign="start center" fxLayoutGap="12px">
              <sbnb-icon icon="scope" class="text-smoke-darker"></sbnb-icon>
              <h3>Scope</h3>
            </div>
          </div>

          <div class="section-content mt-2">
            <div class="default-container" fxLayout fxLayoutAlign="start center" fxLayoutGap="24px">
              <mat-slide-toggle fxFlex="0 0 auto" [(ngModel)]="policy.default" [disabled]="origDefault">
                Set as Default
              </mat-slide-toggle>
              <span class="text__small" *ngIf="!origDefault">
                You can set one booking policy as the default. We'll use this for any properties which haven't been
                assigned to a booking policy.
              </span>
              <span class="text__small" *ngIf="origDefault">
                This is currently your default booking policy. We'll use this for any properties that haven't been
                assigned a booking policy. To change your default policy, set another policy to default.
              </span>
            </div>

            <sbnb-property-selection
              [disabled]="policy.default"
              [selectedProperties]="policy.default ? policy.unscopedProperties : policy.properties"
              [allPropertiesEnabled]="false"
              [border]="true"
              [listHeight]="280"></sbnb-property-selection>
          </div>
        </section>

        <div fxflex fxLayout class="actions">
          <sbnb-button
            *ngIf="mode === 'edit'"
            class="delete mt-4"
            label="Delete"
            icon="delete"
            type="text"
            size="mini"
            [disabled]="origDefault"
            [matTooltip]="
              origDefault ? 'You must set a new default booking policy before you can delete this policy.' : ''
            "
            [labelColor]="'#ED3C6A'"
            (clicked)="deletePolicy()"></sbnb-button>
        </div>
      </section>
    </ng-container>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" title="Direct">
  <sbnb-direct-subnav></sbnb-direct-subnav>
</sbnb-mobile-sidebar>

<ng-template #termsTemplate let-type="type" let-canAddNewTermOfType="canAddNewTermOfType">
  <ng-container *ngFor="let term of policy.terms | cancellationTermsByType: type; let i = index">
    <div class="mt-4">
      <div class="flex">
        <div class="flex grow">
          <sbnb-direct-booking-policy-term-editor [term]="term"></sbnb-direct-booking-policy-term-editor>
        </div>
        <div class="flex" *ngIf="canAddNewTermOfType">
          <sbnb-button type="text" size="mini" (clicked)="addTerm(canAddNewTermOfType, policy)">+ Rule</sbnb-button>
        </div>

        <div class="flex" *ngIf="!canAddNewTermOfType">
          <mat-icon class="delete" matTooltip="Remove this rule" (click)="deleteTerm(term)">delete</mat-icon>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>
